import { t } from '@repo/i18n';
import { useLocale } from '@repo/i18n/react';
import { cn } from '@repo/ui/lib/utils';
import { Link } from 'react-router';
import { BadgesBackground } from './badges-background';
import { LandingButton } from './landing-button';

export const HeroSection = ({ className }: { className?: string }) => {
  useLocale();

  return (
    <section className={cn('relative pt-16', className)} id="home">
      <BadgesBackground badgesPerRow={30} rowsCount={15} />
      <div className="mx-auto flex max-w-6xl flex-col items-start justify-start px-6 py-24 lg:px-10 lg:py-32">
        {/* Badge */}
        <span className="relative z-10 mb-5 inline-block rounded-full bg-landing-pill-bg px-3 py-1 font-medium text-landing-pill-text text-xs">
          {t('landing.smartDueDiligencePlatform')}{' '}
        </span>

        {/* H1 */}
        <h1 className="relative z-10 mb-3 font-bold font-libre-baskerville text-4xl text-[#1B3098] leading-[1.1] tracking-tight lg:text-6xl">
          {t('landing.agenticDueDiligence')}{' '}
        </h1>

        {/* Subtitle line */}
        <p className="relative z-10 mb-6 font-bold font-libre-baskerville text-2xl text-landing-heading-sm leading-tight lg:text-5xl">
          {t('landing.automatedIntelligentTraceable')}{' '}
        </p>

        {/* Body */}
        <p className="relative z-10 mb-8 max-w-2xl text-landing-body text-sm leading-relaxed">
          {t('landing.ravenEmpowersOrganizationsTo')}{' '}
          <span className="text-[#1B3098] decoration-primary/40 underline-offset-2">
            {t('landing.performKycAndKybFasterAndSmarter')}{' '}
          </span>
          {t('copy.heroDescription')}{' '}
        </p>

        {/* CTA buttons */}
        <div className="relative z-10 flex w-full flex-wrap items-center gap-3">
          <LandingButton>
            <Link to="/auth/signin">{t('landing.launchPlatform')}</Link>
          </LandingButton>
          <LandingButton variant="secondary">
            <Link to="/auth/signin">{t('landing.startWithApi')}</Link>
          </LandingButton>
          <LandingButton variant="ghost">
            <a href="#contact">{t('landing.bookADemo')}</a>
          </LandingButton>
        </div>
      </div>
    </section>
  );
};
